/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import { useTranslation } from "react-i18next";
import "./index.less";
export const MultiplePageCard = ({
  title = "",
  subtitle = "",
  titleIcon,
  contentList = [],
}) => {
  return (
    <div className={`multiplePage-card`}>
      <div className="title-top">
        <img src={titleIcon} alt="authing-icon" />
        <div>
          <div className="title-text">{title}</div>
          <div className="subtitle">{subtitle}</div>
        </div>
      </div>
      {contentList.map((item, index) => (
        <>
          <div className="item-list-warp">
            <i class="icon authing-icon authing-checkbox-circle-fill checked"></i>
            <div className="item-list">{item}</div>
          </div>
        </>
      ))}
    </div>
  );
};
export const MultipleAdvantage = () => {
  const { t } = useTranslation();
  const MultiplePageCardOne = {
    title: t("learn.mfaPage.advantage.item1.title"),

    titleIcon: "//files.authing.co/authing-website/mfa-icon-three.png",
    contentList: [
      t("learn.mfaPage.advantage.item1.descript"),
      t("learn.mfaPage.advantage.item1.list1"),
      t("learn.mfaPage.advantage.item1.list2"),
      t("learn.mfaPage.advantage.item1.list3"),
    ],
  };
  const MultiplePageCardTwo = {
    title: t("learn.mfaPage.advantage.item2.title"),

    titleIcon: "//files.authing.co/authing-website/mfa-icon-one.png",
    contentList: [
      t("learn.mfaPage.advantage.item2.descript"),
      t("learn.mfaPage.advantage.item2.list1"),
      t("learn.mfaPage.advantage.item2.list2"),
      t("learn.mfaPage.advantage.item2.list3"),
    ],
  };
  const MultiplePageCardThree = {
    title: t("learn.mfaPage.advantage.item3.title"),
    titleIcon: "//files.authing.co/authing-website/mfa-icon-two.png",
    contentList: [
      t("learn.mfaPage.advantage.item3.list1"),
      t("learn.mfaPage.advantage.item3.list2"),
      t("learn.mfaPage.advantage.item3.list3"),
      t("learn.mfaPage.advantage.item3.list4"),
    ],
  };
  const MultiplePageCardFour = {
    title: t("learn.mfaPage.advantage.item4.title"),
    titleIcon: "//files.authing.co/authing-website/mfa-icon-four.png",
    contentList: [
      t("learn.mfaPage.advantage.item4.descript"),
      t("learn.mfaPage.advantage.item4.list1"),
      t("learn.mfaPage.advantage.item4.list2"),
      t("learn.mfaPage.advantage.item4.list3"),
    ],
  };
  return (
    <div className="multiple-advantage">
      <div className="mfa_page_title">{t("learn.mfaPage.advantage.title")}</div>
      <div className="mfa_page_card_warp">
        <MultiplePageCard {...MultiplePageCardOne} />
        <MultiplePageCard {...MultiplePageCardTwo} />
        <MultiplePageCard {...MultiplePageCardThree} />
        <MultiplePageCard {...MultiplePageCardFour} />
      </div>
    </div>
  );
};
